exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gradient-btn[data-v-5af89058]{background:linear-gradient(45deg,#154669,#01579b,#006064,#00838f);background-size:200% 200%;background-position:50%;border:none;-webkit-transition:background-position .3s ease;transition:background-position .3s ease}.gradient-btn[data-v-5af89058]:hover{background-position:0}", ""]);

// exports
